import commonExtend from '../common/extend';

export default [...commonExtend];
